// Base API URL (you can switch per env)
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/';

// Auth Endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${BASE_URL}authentication/login`,
  REFRESH: `${BASE_URL}authentication/refresh`,
  LOGOUT: `${BASE_URL}authentication/logout`,
  CHANGE_PASSCODE: `${BASE_URL}authentication/passcode`,
};

// Admin Endpoints
export const ADMIN_ENDPOINTS = {
  LIST: `${BASE_URL}admins`,
  CREATE: `${BASE_URL}admins`,
  GET_By_ID: (id) => `${BASE_URL}admins/${id}`,
  UPDATE: (id) => `${BASE_URL}admins/${id}`,
  DELETE: (id) => `${BASE_URL}admins/${id}`,
  PASSCODE: (id) => `${BASE_URL}admins/passcode/${id}`,
};

// Company Endpoints
export const COMPANY_ENDPOINTS = {
  LIST: `${BASE_URL}company`,
  CREATE: `${BASE_URL}company`,
  GET_By_ID: (id) => `${BASE_URL}company/${id}`,
  UPDATE: (id) => `${BASE_URL}company/${id}`,
  DELETE: (id) => `${BASE_URL}company/${id}`,
  PASSCODE: (id) => `${BASE_URL}company/passcode/${id}`,
};

// Customer Endpoints
export const CUSTOMER_ENDPOINTS = {
  LIST: (id)=> `${BASE_URL}customers/${id}/list`,
  CREATE: `${BASE_URL}customers`,
  EDIT: (id)=> `${BASE_URL}customers/${id}`,
  GET_By_ID: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}`,
  UPDATE: (id) => `${BASE_URL}customers/${id}`,
  DELETE: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}`,
  PASSCODE: (id) => `${BASE_URL}customers/${id}/passcode`,
  GET_API_KEY: (id) => `${BASE_URL}customers/${id}/api-key`,
  GET_SETTING: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/settings`,
  GET_CUSTOMER_ACCOUNT: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/account`,
  POST_CUSTOMER_ACCOUNT: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/account`,
  GET_CUSTOMER_DEVICES: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/devices/list`,
  POST_CUSTOMER_DEVICE: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/device/add`,
  PUT_CUSTOMER_DEVICE: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/device/edit`,
  REG_CUSTOMER_DEVICE:(compId, custId) => `${BASE_URL}customers/${compId}/${custId}/device/register`,
  DEVICE_QRCODE: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/device/qrcode`,
  DEVICE_LOGOUT: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/device/logout`,
  DEVICE_DELETE: (compId, custId) => `${BASE_URL}customers/${compId}/${custId}/device/remove`,
};

// Batch Endpoints
export const BATCH_ENDPOINTS = {
  LIST: `${BASE_URL}batch/list`,
  DETAILS_LIST: `${BASE_URL}batch/details/list`,
  CANCEL: `${BASE_URL}batch/cancel`,
  EXPORT: `${BASE_URL}batch/excel-export`,
};

// Logs Endpoints
export const LOGS_ENDPOINTS = {
  LIST: `${BASE_URL}logs/customer`,
};

// Message Endpoints
export const MESSAGE_ENDPOINTS = {
  TEST: `${BASE_URL}message/text/test`,
  BULK_MESSAGE: `${BASE_URL}message/batch-msg`,
};

// Example: File Upload
export const FILE_ENDPOINTS = {
  UPLOAD: `${BASE_URL}/files/upload`,
  DOWNLOAD: (fileId) => `${BASE_URL}/files/${fileId}/download`,
};

// Analytics Endpoints
export const ANALYTICS_ENDPOINTS = {
  CUSTOMER_USAGE_LOWEST: (compId) => `${BASE_URL}analytics/customer_usage/${compId}/lowest`,
  CUSTOMER_LAST_USAGE: (compId) => `${BASE_URL}analytics/customer_usage/${compId}/last`,
};